import { adminConstants } from '../constant/admin-constant';

const initialState = {loading: false, users:{}, editUser:'', addModal:'', editModal:''};
export function userReducer(state = initialState, action){

	switch(action.type){
		case adminConstants.STORE_USER_REQUEST:
			return { ...state, loading:true, editUser:'' }
		case adminConstants.STORE_USER_SUCCESS:
			return { ...state, loading:false};
		case adminConstants.STORE_USER_FAILURE:
			return { ...state, loading:false, error:action.payload };

		case adminConstants.GET_USER_REQUEST:
			return { ...state, loading:true };
		case adminConstants.GET_USER_SUCCESS:
			return { ...state, loading:false, editUser : action.payload.user };
		case adminConstants.GET_USER_FAILURE:
			return { ...state, loading:false, error : action.payload };

		case adminConstants.GET_USERS_REQUEST:
			return { ...state, loading:true, users: {}, editUser:'' };
		case adminConstants.GET_USERS_SUCCESS:
			return { ...state, loading:false , users:action.payload.users};
		case adminConstants.GET_USERS_FAILURE:
			return { ...state, loading:false, error : action.payload };

		case adminConstants.EDIT_USER_REQUEST:
			return { ...state, loading:true };
		case adminConstants.EDIT_USER_SUCCESS:
			return { ...state, loading:false , editUser:action.payload.user};
		case adminConstants.EDIT_USER_FAILURE:
			return { ...state, loading:false, error : action.payload };

		case adminConstants.DELETE_USER_REQUEST:
			return { ...state, loading:true }
		case adminConstants.DELETE_USER_SUCCESS:
			return { ...state, loading:false};
		case adminConstants.DELETE_USER_FAILURE:
			return { ...state, loading:false, error:action.payload };

		case adminConstants.CLOSE_USER_MODAL:
			return { ...state, addModal: 'close' }

		case adminConstants.CLOSE_USER_EDIT_MODAL:
			return { ...state, editModal: 'close' }
		default:
			return { ...state };
	}
}


// WEBPACK FOOTER //
// ./src/redux/reducers/UserReducer.jsx